import forOwn from 'lodash/forOwn';

import { ApiUtils, TypeUtils } from '@vectord/utils';

function normalizedAssociation(association, associations) {
  const { type, id } = association;
  const data = associations[type] && associations[type][id];
  if (data) {
    // eslint-disable-next-line no-use-before-define
    return normalizedSingleEntity(data, associations);
  } else {
    // If association data is not sent then simply return a object with id key
    const _id = parseInt(id, 10);
    return { id: Number.isNaN(_id) ? id : _id };
  }
}

function normalizedSingleEntity(data, associations) {
  const { associations: entityAssociations, ...baseData } = data;
  const normalizedData = baseData;

  forOwn(entityAssociations, (v, k) => {
    if (TypeUtils.isNullOrUndefined(v)) {
      normalizedData[k] = null;
    } else if (Array.isArray(v)) {
      normalizedData[k] = v.map((o) => normalizedAssociation(o, associations));
    } else {
      normalizedData[k] = normalizedAssociation(v, associations);
    }
  });

  return normalizedData;
}

function normalizedDataAndAssociations(data, associations) {
  if (Array.isArray(data)) {
    return data.map((o) => normalizedSingleEntity(o, associations));
  } else if (!TypeUtils.isNullOrUndefined(data)) {
    return normalizedSingleEntity(data, associations);
  } else {
    return null;
  }
}

function normalizeResponse(response) {
  if (!response) return null;

  const _response = ApiUtils.normalizeJsonApiResponse(response);
  const { data, associations, meta } = _response;
  return {
    data: normalizedDataAndAssociations(data, associations),
    meta,
  };
}

export default normalizeResponse;
